export default {
  validateForm: function(rules, errors) {
    const that = this
    return new Promise(async (resolve, reject) => {
      let fieldHasError = false
      let fieldType = null
      let formHasError = false
      let firstTab = null
      for (const idx in rules) {
        const rule = rules[idx]
        fieldHasError = false
        errors[rule.errorKey].hasError = false
        if (rule.required === true) {
          if (rule.value === undefined || rule.value === null) {
            fieldHasError = true
            errors[rule.errorKey].hasError = true
          } else {
            fieldType = rule.type
            if (fieldType === undefined) {
              fieldType = 'string'
            }

            switch (fieldType) {
              case 'image':
              case 'string':
                if (rule.value === undefined || rule.value === null || (typeof rule.value === "string" &&  rule.value.trim().length === 0)) {
                  fieldHasError = true
                  errors[rule.errorKey].hasError = true
                }
                break
              case 'daterange':
                if (
                  rule.value.start === undefined ||
                  rule.value.start === null ||
                  rule.value.start.trim().length === 0 ||
                  rule.value.end === undefined ||
                  rule.value.end === null ||
                  rule.value.end.trim().length === 0
                ) {
                  fieldHasError = true
                  errors[rule.errorKey].hasError = true
                }
                break
              case 'bitMaskCheckboxes':
                if (parseInt(rule.value, 0) === 0) {
                  fieldHasError = true
                  errors[rule.errorKey].hasError = true
                }
                break
              default:
                console.log('validation: unknown fieldtype: ' + fieldType)
            }
          }
        }
        if (!fieldHasError) {
          // additional validations
          switch (fieldType) {
            case 'daterange':
              if (
                rule.value !== undefined &&
                rule.value.start !== undefined &&
                rule.value.start !== null &&
                rule.value.start.trim().length !== 0 &&
                rule.value.end !== undefined &&
                rule.value.end !== null &&
                rule.value.end.trim().length !== 0 &&
                new Date(rule.value.end).getTime() <
                  new Date(rule.value.start).getTime()
              ) {
                fieldHasError = true
                errors[rule.errorKey].hasError = true
                errors[rule.errorKey].errorText =
                  '"Bis" muss grösser/gleich als "Von" sein'
              }
              break
            case 'image':
              if (rule.image !== undefined) {
                //check ratio
                let imgSize = await that.getImageSize(rule.value)
                const imgRatio = Math.round(
                  Math.floor((imgSize.w / imgSize.h) * 1000) / 10
                )
                const expectedRatio = Math.round(
                  Math.floor(rule.ratio * 1000) / 10
                )
                if (rule.ratio !== undefined && imgRatio != expectedRatio) {
                  fieldHasError = true
                  errors[rule.errorKey].hasError = true
                  errors[rule.errorKey].errorText =
                    'Das Bild muss ein Seitenverhältnis von ' +
                    rule.ratioName +
                    ' haben'
                } else if (
                  rule.minWidth !== undefined &&
                  imgSize.w < rule.minWidth
                ) {
                  //check width
                  fieldHasError = true
                  errors[rule.errorKey].hasError = true
                  errors[rule.errorKey].errorText =
                    'Das Bild muss mindestens ' +
                    rule.minWidth +
                    'px breit sein'
                } else if (
                  rule.minHeight !== undefined &&
                  imgSize.h < rule.minHeight
                ) {
                  //check height
                  fieldHasError = true
                  errors[rule.errorKey].hasError = true
                  errors[rule.errorKey].errorText =
                    'Das Bild muss mindestens ' +
                    rule.minHeight +
                    'px hoch sein'
                }
              }
              break
          }
        }
        if (!fieldHasError && rule.customRule !== undefined) {
          //check custom rules
          await rule.customRule.then(
            () => {
              //ok
            },
            errorMessage => {
              fieldHasError = true
              errors[rule.errorKey].hasError = true
              errors[rule.errorKey].errorText = errorMessage
            }
          )
        }
        if (fieldHasError) {
          if (rule.tab !== undefined && firstTab === null) {
            firstTab = rule.tab
          }
          formHasError = true
        }
      }
      if (firstTab !== null) {
        history.pushState(
          {},
          null,
          window.document.location.pathname + '#' + firstTab
        )
        window.dispatchEvent(new HashChangeEvent('hashchange'))
      }
      if (!formHasError) {
        resolve()
      }
    })
  },
  getImageSize(file) {
    return new Promise(function(resolved, rejected) {
      const i = new Image()
      i.onload = function() {
        resolved({ w: i.width, h: i.height })
      }
      i.src = file
    })
  }
}
